import styled from 'styled-components';

export const StyledB2ETokenDesktop = styled.section`
  .container {
    max-width: 1216px;
    margin: 0 auto;
    padding-top: 64px;
    width: 100%;
    .header {
      text-align: center;
      .t-1 {
        line-height: 80px;
      }
    }
    .content-box {
      margin: 32px 0 192px 0;
      width: 100%;
    }
  }
`;
